var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLegacyplanning20(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 34.3334V10.3334C13 9.62617 13.281 8.94789 13.7811 8.4478C14.2812 7.9477 14.9594 7.66675 15.6667 7.66675H26.3334C27.0406 7.66675 27.7189 7.9477 28.219 8.4478C28.7191 8.94789 29 9.62617 29 10.3334V34.3334M13 34.3334H29M13 34.3334H10.3334C9.62611 34.3334 8.94783 34.0525 8.44774 33.5524C7.94764 33.0523 7.66669 32.374 7.66669 31.6667V23.6667C7.66669 22.9595 7.94764 22.2812 8.44774 21.7811C8.94783 21.281 9.62611 21.0001 10.3334 21.0001H13M29 34.3334H31.6667C32.3739 34.3334 33.0522 34.0525 33.5523 33.5524C34.0524 33.0523 34.3334 32.374 34.3334 31.6667V19.6667C34.3334 18.9595 34.0524 18.2812 33.5523 17.7811C33.0522 17.281 32.3739 17.0001 31.6667 17.0001H29M18.3334 13.0001H23.6667M18.3334 18.3334H23.6667M18.3334 23.6667H23.6667M18.3334 29.0001H23.6667",
    stroke: "url(#paint0_linear_714_170)",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_714_170",
    x1: 21,
    y1: 7.66675,
    x2: 21,
    y2: 34.3334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63363A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F4E62"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegacyplanning20);
export default __webpack_public_path__ + "static/media/legacyplanning2.0.c273a908782572f89ae8cf9968775637.svg";
export { ForwardRef as ReactComponent };